import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { TagGi } from '../models/tag-gi';
import { UsuarioIntegrador } from '../models/usuario-integrador';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class UsuarioIntegradorService {


  constructor(private globalService: GlobalService, private http: HttpClient) {

  }



  consultarUsuarioIntegradorComPaginacao(idIntegrador: number, nome: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('idIntegrador', idIntegrador.toString());

    if (nome.trim() !== '') {
      parametros = parametros.set('nome', nome);
    }

    return this.http.get<any>(globals.apiUrl + '/api/UsuarioIntegrador/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/UsuarioIntegrador/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(usuarioIntegrador: UsuarioIntegrador) {
    return this.http.post(globals.apiUrl + '/api/UsuarioIntegrador/Salvar', usuarioIntegrador);
  }



  consultarPorIdIntegrador(idIntegrador) {
    return this.http.get<any>(globals.apiUrl + '/api/UsuarioIntegrador/ListarPorIdIntegrador',
      { params: new HttpParams().set('idIntegrador', idIntegrador) });
  }
}
